import React from 'react';
export function Footer() {
  return <footer className="bg-ink py-8 text-center px-4" data-id="element-127" data-mp="32wd2qgad7ltj">
      <div className="max-w-4xl mx-auto" data-id="element-128" data-mp="3gfsnyg23r0ok">
        <p className="text-white/60 text-sm" data-id="element-129" data-mp="3ggu1cr6lbz9g">
          © 2026 Boxing Coach Ready — All Rights Reserved.
        </p>
      </div>
    </footer>;
}